import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/supplier',
    meta: { title: '供应商登记' },
    redirect: '/supplier/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: { title: '供应商信息管理', activeMenu: '/supplier' },
        component: () => import('@/views/supplier/Supplier.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑供应商信息',
          activeMenu: '/supplier'
        },
        component: () => import('@/views/supplier/SupplierAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '供应商信息详情',
          activeMenu: '/supplier'
        },
        component: () => import('@/views/supplier/SupplierDetail.vue')
      }

    ]
  },
  {
    path: '/cpyCategory',
    meta: { title: '成品油类型管理' },
    component: Layout,
    redirect: '/cpyCategory/list',
    children: [
      {
        path: 'list',
        meta: { title: '成品油类型管理', activeMenu: '/cpyCategory' },
        component: () => import('@/views/cpyCategory/Index.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增成品油类型',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑成品油类型',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '成品油类型详情',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryDetail.vue')
      }

    ]
  }
]
